import { render, staticRenderFns } from "./KedisiplinanPegawai.vue?vue&type=template&id=565ab35b&scoped=true"
import script from "./KedisiplinanPegawai.vue?vue&type=script&lang=js"
export * from "./KedisiplinanPegawai.vue?vue&type=script&lang=js"
import style0 from "./KedisiplinanPegawai.vue?vue&type=style&index=0&id=565ab35b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ab35b",
  null
  
)

export default component.exports